/* ========================================
   CREMED ショップ機能
   - バリエーション（個数）選択と価格更新
   - カスタムセットのフレーバービルダー
   - 一覧からのクイック追加
   - スライド式カートドロワー（AJAX / Section Rendering API）
   ======================================== */
(function () {
  'use strict';

  var DRAWER_SECTION = 'cart-drawer';

  /* ---------- ユーティリティ ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- カートドロワー ---------- */
  function openDrawer() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function applyDrawerHTML(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newContent = doc.querySelector('[data-cart-drawer-content]');
    var liveContent = $('[data-cart-drawer-content]');
    if (newContent && liveContent) liveContent.innerHTML = newContent.innerHTML;

    var countEl = doc.querySelector('[data-cart-total-count]');
    var count = countEl ? parseInt(countEl.textContent, 10) : null;
    if (count !== null && !isNaN(count)) updateCartCount(count);
  }

  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function refreshDrawer() {
    return fetch('?sections=' + DRAWER_SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyDrawerHTML(data[DRAWER_SECTION]); });
  }

  function addToCart(item, opts) {
    opts = opts || {};
    var body = Object.assign({}, item, { sections: DRAWER_SECTION, sections_url: window.location.pathname });
    return postJSON('/cart/add.js', body).then(function (res) {
      if (res.status) { // エラー（在庫切れ等）
        if (opts.onError) opts.onError(res);
        return;
      }
      if (res.sections && res.sections[DRAWER_SECTION]) {
        applyDrawerHTML(res.sections[DRAWER_SECTION]);
      } else {
        refreshDrawer();
      }
      openDrawer();
    });
  }

  function changeLine(key, quantity) {
    return postJSON('/cart/change.js', {
      id: key, quantity: quantity, sections: DRAWER_SECTION, sections_url: window.location.pathname
    }).then(function (res) {
      if (res.sections && res.sections[DRAWER_SECTION]) {
        applyDrawerHTML(res.sections[DRAWER_SECTION]);
      } else {
        refreshDrawer();
      }
    });
  }

  /* ---------- グローバルなクリック委譲 ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); refreshDrawer(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    // ドロワー内 数量変更
    var lineMinus = e.target.closest('[data-line-minus]');
    var linePlus = e.target.closest('[data-line-plus]');
    var lineRemove = e.target.closest('[data-line-remove]');
    var lineEl = e.target.closest('[data-line-key]');
    if (lineEl && (lineMinus || linePlus || lineRemove)) {
      e.preventDefault();
      var key = lineEl.getAttribute('data-line-key');
      var qtyEl = $('[data-line-qty]', lineEl);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (lineRemove) { changeLine(key, 0); }
      else if (linePlus) { changeLine(key, qty + 1); }
      else if (lineMinus) { changeLine(key, Math.max(0, qty - 1)); }
      return;
    }

    // 一覧カードのクイック追加
    var qaOpen = e.target.closest('[data-qa-open]');
    if (qaOpen) {
      e.preventDefault();
      var card = qaOpen.closest('[data-product-card]');
      var pop = card ? $('[data-qa-pop]', card) : null;
      if (pop) {
        var willOpen = pop.hasAttribute('hidden');
        $all('[data-qa-pop]').forEach(function (p) { if (p !== pop) p.setAttribute('hidden', ''); });
        if (willOpen) { pop.removeAttribute('hidden'); qaOpen.setAttribute('aria-expanded', 'true'); }
        else { pop.setAttribute('hidden', ''); qaOpen.setAttribute('aria-expanded', 'false'); }
      }
      return;
    }

    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd && !quickAdd.disabled) {
      e.preventDefault();
      var vid = quickAdd.getAttribute('data-variant-id');
      if (!vid) return;
      var original = quickAdd.textContent;
      quickAdd.disabled = true;
      quickAdd.classList.add('is-loading');
      addToCart({ id: vid, quantity: 1 }).then(function () {
        quickAdd.disabled = false;
        quickAdd.classList.remove('is-loading');
        var pop = quickAdd.closest('[data-qa-pop]');
        if (pop) pop.setAttribute('hidden', '');
      });
      return;
    }

    // ポップオーバー外クリックで閉じる
    if (!e.target.closest('[data-qa-pop]') && !e.target.closest('[data-qa-open]')) {
      $all('[data-qa-pop]').forEach(function (p) { p.setAttribute('hidden', ''); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- クーポンコード（購入手続きへ引き継ぎ） ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-checkout-submit]');
    if (!btn) return;
    var form = btn.closest('form');
    var input = form ? $('[data-discount-input]', form) : null;
    var code = input ? input.value.trim() : '';
    if (!code) return; // コード未入力の場合は通常どおりカートフォームを送信

    e.preventDefault();
    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
  });

  // クーポンコード欄で Enter → 「更新」ではなく購入手続きへ進める
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-input]');
    if (!input) return;
    var form = input.closest('form');
    var checkoutBtn = form ? $('[data-checkout-submit]', form) : null;
    if (!checkoutBtn) return;
    e.preventDefault();
    checkoutBtn.click();
  });

  /* ---------- コレクション: 並び替え ---------- */
  document.addEventListener('change', function (e) {
    var sortSelect = e.target.closest('[data-sort-select]');
    if (!sortSelect) return;
    var form = sortSelect.closest('form');
    if (form) form.submit();
  });

  /* ========================================
     商品ページ
     ======================================== */
  function initProductPage() {
    var section = $('[data-product-section]');
    if (!section) return;

    var form = $('.product-form', section);
    var variantInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-btn]', section);
    var addLabel = $('[data-add-label]', section);
    var priceEls = $all('[data-price]', section);
    var isCustom = section.hasAttribute('data-custom-set');

    var variants = [];
    var dataEl = $('[data-variants]', section);
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; } }

    /* --- 選択中バリエーションの解決 --- */
    function selectedOptionValues() {
      var groups = $all('.opt-group', section);
      return groups.map(function (g) {
        var checked = $('input[data-option-input]:checked', g);
        return checked ? checked.value : null;
      });
    }

    function matchVariant() {
      var sel = selectedOptionValues();
      if (!sel.length) return variants[0];
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function requiredCount(variant) {
      if (!variant) return 0;
      var joined = variant.options.join(' ');
      var m = joined.match(/(\d+)\s*個/) || joined.match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 0;
    }

    /* --- フレーバービルダー --- */
    var builder = $('[data-builder]', section);
    var required = 0;

    function builderTotal() {
      return $all('[data-flavor-row]', builder).reduce(function (sum, row) {
        return sum + parseInt($('[data-flavor-count]', row).textContent, 10);
      }, 0);
    }

    function resetBuilder() {
      if (!builder) return;
      $all('[data-flavor-row]', builder).forEach(function (row) {
        $('[data-flavor-count]', row).textContent = '0';
      });
      updateBuilder();
    }

    function updateBuilder() {
      if (!builder) return;
      var total = builderTotal();
      var remaining = Math.max(0, required - total);
      var remEl = $('[data-builder-remaining]', builder);
      if (remEl) remEl.textContent = remaining;
      var targetEl = $('[data-builder-target]', builder);
      if (targetEl) targetEl.textContent = required;

      // ＋ボタンの可否
      $all('[data-flavor-row]', builder).forEach(function (row) {
        var plus = $('[data-flavor-plus]', row);
        if (plus) plus.disabled = (total >= required);
      });

      // プロパティ文字列を構成
      var parts = [];
      $all('[data-flavor-row]', builder).forEach(function (row) {
        var n = parseInt($('[data-flavor-count]', row).textContent, 10);
        if (n > 0) parts.push(row.getAttribute('data-flavor-name') + ' × ' + n);
      });
      var prop = $('[data-builder-prop]', builder);
      if (prop) prop.value = parts.join('、');

      var hint = $('[data-builder-hint]', builder);
      if (hint) {
        if (required === 0) hint.textContent = '個数を選ぶと、お好きなフレーバーを詰められます。';
        else if (total < required) hint.textContent = 'あと ' + remaining + ' 個 選んでください。';
        else hint.textContent = 'ぴったり ' + required + ' 個 選べました。';
      }
      updateAddState();
    }

    /* --- 価格表示（未選択時はプロンプト） --- */
    var PRICE_PROMPT = '<span class="product-price__prompt">個数をお選びください</span>';
    function setPrice(v) {
      priceEls.forEach(function (el) {
        el.innerHTML = v ? '<span class="price">' + v.price_html + '</span>' : PRICE_PROMPT;
      });
    }

    /* --- 在庫・購入ボタン状態 --- */
    function updateAddState() {
      var v = matchVariant();
      var ok = !!(v && v.available);
      if (isCustom && builder) {
        ok = ok && required > 0 && builderTotal() === required;
      }
      if (addBtn) addBtn.disabled = !ok;
      if (addLabel) {
        if (!v) addLabel.textContent = '個数を選択';
        else if (!v.available) addLabel.textContent = '在庫切れ';
        else if (isCustom && builderTotal() !== required) addLabel.textContent = 'フレーバーを選ぶ';
        else addLabel.textContent = 'カートに入れる';
      }
    }

    function onVariantChange() {
      var v = matchVariant();
      setPrice(v);
      if (variantInput && v) variantInput.value = v.id;
      if (isCustom) {
        required = requiredCount(v);
        resetBuilder();
      } else {
        updateAddState();
      }
    }

    /* --- イベント --- */
    $all('input[data-option-input]', section).forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });

    if (builder) {
      builder.addEventListener('click', function (e) {
        var plus = e.target.closest('[data-flavor-plus]');
        var minus = e.target.closest('[data-flavor-minus]');
        if (!plus && !minus) return;
        var row = e.target.closest('[data-flavor-row]');
        var countEl = $('[data-flavor-count]', row);
        var n = parseInt(countEl.textContent, 10);
        if (plus && builderTotal() < required) n++;
        if (minus && n > 0) n--;
        countEl.textContent = n;
        updateBuilder();
      });
    }

    /* --- 数量ステッパー --- */
    var qtyInput = $('[data-qty-input]', section);
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-plus]')) { qtyInput.value = parseInt(qtyInput.value, 10) + 1; }
      if (e.target.closest('[data-qty-minus]')) { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); }
    });

    /* --- ギャラリー サムネイル --- */
    var galleryMain = $('[data-gallery-main]', section);
    $all('[data-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (galleryMain) { galleryMain.src = thumb.getAttribute('data-thumb'); galleryMain.srcset = ''; }
      });
    });

    /* --- フォーム送信（AJAX） --- */
    function cartItemFromForm() {
      var props = {};
      $all('[name^="properties["]', form).forEach(function (input) {
        var key = input.name.replace('properties[', '').replace(']', '');
        if (input.value) props[key] = input.value;
      });
      var item = { id: variantInput.value, quantity: parseInt(qtyInput.value, 10) || 1 };
      if (Object.keys(props).length) item.properties = props;
      return item;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        if (addBtn) addBtn.classList.add('is-loading');
        addToCart(cartItemFromForm(), {
          onError: function (res) { if (addLabel) addLabel.textContent = res.description || '追加できませんでした'; }
        }).then(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
          if (isCustom) resetBuilder();
        });
      });
    }

    /* --- スマホ固定購入バー --- */
    var buyBar = $('[data-buy-bar]', section);
    var buyBarAdd = $('[data-buy-bar-add]', section);
    if (buyBarAdd && form) {
      buyBarAdd.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    }
    if (buyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          buyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      if (addBtn) io.observe(addBtn);
    }

    // 初期化
    onVariantChange();
  }

  /* ---------- 起動 ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
